const EUROPEAN_COUNTRY_CODES = new Set([
  'AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR',
  'GI', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL',
  'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
]);

const getFooterVisitorCountryCode = () => {
  const shopifyCountry =
    window.Shopify?.country ||
    window.Shopify?.localization?.country?.iso_code;

  if (shopifyCountry) return String(shopifyCountry).toUpperCase();

  const countryInput = document.querySelector(
    '.localization-form input[name="country_code"], input[name="country_code"]'
  );

  if (countryInput?.value) return String(countryInput.value).toUpperCase();

  return '';
};

const shouldRenderEuropeanFooterLinks = () => {
  if (document.documentElement.classList.contains('shopify-design-mode')) return true;
  return EUROPEAN_COUNTRY_CODES.has(getFooterVisitorCountryCode());
};

const normalizeFooterLinkHref = (href) => {
  if (!href) return '';

  try {
    const url = new URL(href, window.location.origin);
    return `${url.origin}${url.pathname}${url.hash}`;
  } catch (error) {
    return href;
  }
};

const ensureRightOfWithdrawalFooterLink = () => {
  if (!shouldRenderEuropeanFooterLinks()) return;

  const footerMenus = document.querySelectorAll('.footer__menu--sublinks-container');
  if (!footerMenus.length) return;

  footerMenus.forEach((menu) => {
    const links = Array.from(menu.querySelectorAll('a'));
    const hasRightOfWithdrawal = links.some((link) => {
      const href = normalizeFooterLinkHref(link.getAttribute('href'));
      return href === 'https://returns.unboundmerino.com/' && link.textContent.trim().toLowerCase() === 'right of withdrawal';
    });

    if (hasRightOfWithdrawal) return;

    const shippingAndReturnsLink = links.find((link) => {
      const href = normalizeFooterLinkHref(link.getAttribute('href'));
      return href === `${window.location.origin}/pages/shipping-and-returns`
        || href === 'https://unboundmerino.com/pages/shipping-and-returns'
        || link.textContent.trim().toLowerCase() === 'shipping and returns';
    });

    if (!shippingAndReturnsLink) return;

    const rightOfWithdrawalItem = document.createElement('li');
    rightOfWithdrawalItem.className = 'footer__menu--sublink';
    rightOfWithdrawalItem.innerHTML = '<a href="https://returns.unboundmerino.com/">Right of Withdrawal</a>';

    shippingAndReturnsLink.closest('li')?.insertAdjacentElement('afterend', rightOfWithdrawalItem);
  });
};

document.addEventListener('DOMContentLoaded', ensureRightOfWithdrawalFooterLink);
window.addEventListener('pageshow', ensureRightOfWithdrawalFooterLink);
